import React, { useState } from 'react'
import { Button, ButtonGroup, Grid, Menu, MenuItem, withStyles, ListItemIcon, ListItemText } from '@material-ui/core'
import useRouter from 'utils/useRouter'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import AddIcon from '@material-ui/icons/Add'
import PhotoIcon from '@material-ui/icons/Photo'
import EditIcon from '@material-ui/icons/Edit'
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle'
import { ModalGerenciarAcesso } from 'components/ModalGerenciarAcesso'
import { useAuth } from 'hooks/useAuth'
import useStyles from './styles'

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.secondary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

export const MenuAcoes = (props) => {
  const classes = useStyles()
  const { veiculo, idVeiculo } = props
  const router = useRouter()
  const [anchorEl, setAnchorEl] = useState(null)
  const [isGerenciarAcessoOpen, setIsGerenciarAcessoOpen] = useState(false)
  const { currentUser } = useAuth()

  const handleClickBotaoAcoes = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuBotaoAcoes = (to) => {
    router.history.push(to)
  }

  return (
    <Grid alignItems="flex-end" container spacing={1}>
      <Grid item>
        <ButtonGroup aria-controls="customized-menu" className={classes.actions} aria-haspopup="true" variant="contained" color="primary">
          <Button onClick={handleClickBotaoAcoes} endIcon={<ArrowDropDownIcon />}>
            Ações
          </Button>
        </ButtonGroup>
        <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          <>
            <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/casos/caso/editarveiculo/${idVeiculo}`)}>
              <ListItemIcon>
                <EditIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Editar veículo" />
            </StyledMenuItem>

            <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/casos/caso/veiculo/extrair/${idVeiculo}`)}>
              <ListItemIcon>
                <AddIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Extrair vestígio" />
            </StyledMenuItem>

            <StyledMenuItem onClick={() => router.history.push(`/galeria/veiculo/${idVeiculo}`)}>
              <ListItemIcon>
                <PhotoIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Ver galeria" />
            </StyledMenuItem>

            {currentUser.cargo.id === 1 && (
              <StyledMenuItem onClick={() => setIsGerenciarAcessoOpen(true)}>
                <ListItemIcon>
                  <SupervisedUserCircleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Conceder acesso à galeria" />
              </StyledMenuItem>
            )}
          </>
        </StyledMenu>
      </Grid>
      <ModalGerenciarAcesso open={isGerenciarAcessoOpen} onClose={() => setIsGerenciarAcessoOpen(false)} idCaso={veiculo?.id_caso} usuarios={[]} selecionados={[]} />
    </Grid>
  )
}
